/*
 * @Descripttion:
 * @version:
 * @Author: Mark
 * @Date: 2020-05-25 15:58:13
 * @LastEditors: Mark
 * @LastEditTime: 2020-05-26 11:37:44
 */

import axios from 'axios'
import store from '@/store/index'

// const debug = process.env.NODE_ENV !== 'production'
// const baseURL = debug ? '/' : 'https://mp.api.mgtv.com/'

const SUCCESS_CODE = [200, 0]
  // 超时逻辑
;(axios.defaults as any).retry = 3
;(axios.defaults as any).retryDelay = 2000

const instance = axios.create({
  // baseURL: baseURL,
  timeout: 10000,
})

// eslint-disable-next-line complexity
instance.interceptors.request.use((config: any) => {
  // 填充uuid 和 ticket 字段
  const userInfoInapp = store.state.userInfoInapp
  if (config.method == 'get') {
    !config.params.uuid && (config.params.uuid = userInfoInapp.uuid || '')
    !config.params.ticket && (config.params.ticket = userInfoInapp.ticket || '')
    if (config.params.cache == 1) {
      config.headers['Cache-Control'] = ''
    }
  }

  if (config.method == 'post') {
    // const data = config.data
    // !data.uuid && (data.uuid = userInfoInapp.uuid || '')
    // !data.ticket && (data.ticket = userInfoInapp.ticket || '')
    config.url = `${config.url}?uuid=${userInfoInapp.uuid || ''}&ticket=${
      userInfoInapp.ticket
    }`
  }
  return config
})

instance.interceptors.response.use(
  response => {
    return new Promise((resolve, reject) => {
      if (SUCCESS_CODE.includes(response.status)) {
        resolve(response.data)
      } else {
        reject(response)
      }
    })
  },
  err => {
    const config = err.config
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err)

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(err)
    }

    // Increase the retry count
    config.__retryCount += 1

    // Create new promise to handle exponential backoff
    const backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve()
      }, config.retryDelay || 1)
    })

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
      return axios(config)
    })
  }
)

export default instance
